import React from 'react'
import styled from 'styled-components'
import { GENERAL } from '@laputan/core'
import { Link } from '../../components/Link'
import { Text } from '../../components/Text'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import { CONFIG } from '../../config'
import GooglePlayStoreImageSrc from './images/google-play.png'
import { PageRoutes } from '../constants/PageRoutes'
import { AroundSchoolsLogo } from '../Image/AroundSchoolsLogo'

const AppStoreImagesContainer = styled.div`
  text-align: center;
  margin-bottom: 1rem;
  ${SCREEN_SIZE.MD} {
    text-align: right;
  }
`

const AppStoreImageLink = styled.a.attrs({
  target: '_blank',
})``

const AppStoreImage = styled.img`
  height: 2.6rem;
  width: 8.75rem;
`

const AboutLaputanSchoolsText = styled(Text)`
  display: block;
  max-width: 26rem;
  margin-top: 0.5rem;
  line-height: 1.4rem;
  color: ${STYLES.COLOR_HIT_GRAY};
`

const StyledFooter = styled.footer`
  background-color: #333;
  padding: 2rem ${STYLES.CONTENT_PADDING};
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${SCREEN_SIZE.MD} {
    flex-direction: row;
    align-items: initial;
  }
`

const FooterLeft = styled.div`
  flex: 1;
  text-align: center;
  margin-bottom: 2rem;
  ${SCREEN_SIZE.MD} {
    text-align: left;
    margin-bottom: 0;
  }
`

const FooterRight = styled.div`
  flex: 1;
  flex-direction: column;
  text-align: right;
  display: flex;
`

const FooterRightBottom = styled.div`
  padding-top: 1.4rem;
  text-align: center;
  ${SCREEN_SIZE.MD} {
    text-align: right;
  }
`

const Copyright = styled.div`
  margin-top: ${STYLES.GUTTER};
`

const StyledLink = styled(Link).attrs({
  to: GENERAL.LAPUTAN_WEBSITE_URL,
  target: '_blank',
})`
  display: inline;
  color: ${STYLES.PRIMARY_COLOR};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const FooterLink = styled(Link)`
  margin-bottom: 1rem;
  white-space: nowrap;
  ${SCREEN_SIZE.MD} {
    margin-bottom: 0;
  }
`

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: ${STYLES.GUTTER};
  ${SCREEN_SIZE.MD} {
    flex-direction: row;
  }
`

const Separator = styled.div.attrs({
  children: '|',
})`
  display: none;
  ${SCREEN_SIZE.MD} {
    display: block;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`

const Footer = () => (
  <StyledFooter>
    <FooterLeft>
      <Link to="/">
        <AroundSchoolsLogo />
      </Link>
      <AboutLaputanSchoolsText>
        {CONFIG.WEBSITE_DESCRIPTION}
      </AboutLaputanSchoolsText>
    </FooterLeft>
    <FooterRight>
      <AppStoreImagesContainer>
        <AppStoreImageLink href="https://play.google.com/store/apps/details?id=au.com.aroundschools">
          <AppStoreImage src={GooglePlayStoreImageSrc} />
        </AppStoreImageLink>
      </AppStoreImagesContainer>
      <FooterLinks>
        <FooterLink to={PageRoutes.ADVERTISE_BASIC_SCHOOL_PLAN}>
          Advertise your school
        </FooterLink>
        <Separator />
        <FooterLink to={PageRoutes.ADVERTISE_BASIC_ACTIVITY_PLAN}>
          Advertise your activity
        </FooterLink>
      </FooterLinks>
      <FooterLinks>
        <FooterLink to={PageRoutes.BLOG}>Blog</FooterLink>
        <Separator />
        <FooterLink to={PageRoutes.DEVELOPERS}>Developers</FooterLink>
      </FooterLinks>
      <FooterLinks>
        <FooterLink to={PageRoutes.PRIVACY}>Privacy Policy</FooterLink>
        <Separator />
        <FooterLink to={PageRoutes.TERMS_AND_CONDITIONS}>
          Terms & Conditions
        </FooterLink>
      </FooterLinks>
      <FooterLinks>
        <FooterLink to={PageRoutes.SITEMAP}>Site Index</FooterLink>
      </FooterLinks>
      <FooterRightBottom>
        <Link to="mailto:info@aroundschools.com.au">
          info@aroundschools.com.au
        </Link>
        <Copyright>
          &copy; 2016 - {new Date().getFullYear()}&nbsp;
          <StyledLink>Laputan Pty Ltd.</StyledLink>
        </Copyright>
      </FooterRightBottom>
    </FooterRight>
  </StyledFooter>
)

export { Footer }
